import { useState, useEffect } from 'react';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm border-b border-background-200/50'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-18">
          <a href="/" className="flex items-center gap-2 shrink-0" aria-label="SaloonS Ana Sayfa">
            <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
              <i className="ri-sparkling-line text-background-50 text-lg"></i>
            </span>
            <span className="text-base md:text-lg font-bold text-foreground-900 font-heading whitespace-nowrap leading-tight">
              Saloon<span className="text-primary-500">S</span>
            </span>
          </a>

          <div className="hidden md:flex items-center gap-6">
            <button
              onClick={() => scrollToSection('hero')}
              className="text-sm font-medium text-foreground-600 hover:text-foreground-900 transition-colors cursor-pointer whitespace-nowrap"
            >
              Ana Sayfa
            </button>
            <button
              onClick={() => scrollToSection('reviews')}
              className="text-sm font-medium text-foreground-600 hover:text-foreground-900 transition-colors cursor-pointer whitespace-nowrap"
            >
              Yorumlar
            </button>
            <button
              onClick={() => scrollToSection('categories')}
              className="text-sm font-medium text-foreground-600 hover:text-foreground-900 transition-colors cursor-pointer whitespace-nowrap"
            >
              İşlemler
            </button>
            <button
              onClick={() => scrollToSection('footer')}
              className="text-sm font-medium text-foreground-600 hover:text-foreground-900 transition-colors cursor-pointer whitespace-nowrap"
            >
              İletişim
            </button>
          </div>

          <div className="flex items-center gap-3">
            <a
              href="https://wa.me/905433724578?text=Merhaba%2C%20randevu%20almak%20istiyorum."
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="flex items-center gap-1.5 px-4 py-2 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-whatsapp-fill"></i>
              </span>
              Randevu Al
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
}